const JAPAN_POSTAL_CODE_REGEXP = /(\d{7})|(\d{3}-\d{4})/;
export function extractJapanPostalCode(text) {
  var _text$match;
  return (_text$match = text.match(JAPAN_POSTAL_CODE_REGEXP)) == null ? void 0 : _text$match[0];
}
//# sourceMappingURL=postal-code.js.map